import qs from 'query-string'
import redirects from '../config/redirects.json'


export const parseRedirectQuery = query => {
    const {redirect_url} = qs.parse(query)
    const url = redirect_url && redirects[redirect_url]
    return url
}

export const tryRedirectToAffiliate = query => {
    const url = parseRedirectQuery(query)

    if (url) {
        window.location = url
        return true
    }

    return false
}
